import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { JobRating } from "../../common/JobOrder";
import {
  MarinerProfile,
  marinerSearchParams,
} from "../../common/MarinerProfile";
import { useGetMarinersQuery } from "../../redux/api/mariner";

interface MarinerProfileAutocompleteProps {
  id: string;
  value: MarinerProfile | null;
  marinerRating?: JobRating;
  disabled?: boolean;
  onChange: (m: MarinerProfile | undefined) => void;
}

const MarinerProfileAutocomplete = (props: MarinerProfileAutocompleteProps) => {
  const [searchParams, setSearchParams] = useState<marinerSearchParams>({
    search: !!props.value
      ? `${props.value.firstName} ${props.value.lastName} - ${
          props.value.mmcId
        } - ${props.value.rating?.substring(1)}`
      : "",
    ratings: [],
    vesselId: undefined,
    registered: undefined,
    compatibleWithRating: props.marinerRating as string,
    smis: "",
    veteran: undefined,
    trainingStatus: "",
    page: 0,
    size: 90,
    sortColumn: "firstName",
    sortDirection: "asc",
  });

  useEffect(() => {
    setSearchParams({
      ...searchParams,
      search: !!props.value
        ? `${props.value.firstName} ${props.value.lastName} - ${
            props.value.mmcId
          } - ${props.value.rating?.substring(1)}`
        : "",
      compatibleWithRating: props.marinerRating as string,
    });
    // do not include searchParams in the dependency array as it will lead to a loop and does not make sense here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value, props.marinerRating]);

  const { data: marinerProfiles, isLoading } =
    useGetMarinersQuery(searchParams);

  return (
    <>
      {!isLoading && (
        <Autocomplete
          id={props.id}
          options={marinerProfiles?.content as MarinerProfile[]}
          value={props.value}
          onInputChange={(event, value: string) =>
            setSearchParams({ ...searchParams, search: value })
          }
          clearOnEscape={true}
          clearOnBlur={true}
          getOptionLabel={(profile) =>
            `${profile.firstName} ${profile.lastName} - ${
              profile.mmcId
            } - ${profile.rating?.substring(1)}`
          }
          renderInput={(params) => <TextField {...params} />}
          onChange={(event, value) => {
            if (value) {
              props.onChange(value);
            } else {
              props.onChange(undefined);
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return option.id === value.id;
          }}
          disabled={props.disabled ? props.disabled : false}
        />
      )}
    </>
  );
};

export default MarinerProfileAutocomplete;
